// REST client for Google Vertex AI integrations, one per Google Cloud org.
import { idForPath, restDelete, restGet, restPatch, restPost } from "./restClient.js";

const ROOT = "/v1/vertex-integrations";

export function listVertexIntegrations({ signal } = {}) {
    return restGet(ROOT, null, { signal });
}

export function createVertexIntegration({ organizationId, datasetProjectId, datasetId, serviceAccountKey, projectIds }) {
    return restPost(ROOT, {
        organization_id: organizationId,
        dataset_project_id: datasetProjectId,
        dataset_id: datasetId,
        service_account_key: serviceAccountKey,
        project_ids: projectIds,
    });
}

export function replaceVertexKey(integrationId, serviceAccountKey) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { service_account_key: serviceAccountKey });
}

export function changeVertexScope(integrationId, { datasetProjectId, datasetId, projectIds }) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, {
        dataset_project_id: datasetProjectId,
        dataset_id: datasetId,
        project_ids: projectIds,
        all_projects: projectIds.length === 0,
    });
}

export function deleteVertexIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}
